import { render } from "./import-personal.vue?vue&type=template&id=16fb1d58&scoped=true"
import script from "./import-personal.vue?vue&type=script&lang=js"
export * from "./import-personal.vue?vue&type=script&lang=js"

import "./import-personal.vue?vue&type=style&index=0&id=16fb1d58&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fb1d58"]])

export default __exports__